module.exports = __webpack_public_path__ + "e6f22cc25cd2a5f76b999af4c71bf3c5.png";